import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'anatoliapps-angular/services';

import { Donation } from 'hakikat/models';
import { API_CONFIG } from 'hakikat/utils';


export interface CreateDonationInput {
  id: string;
  
  itemIds: string[];

  regionId: string;

  type: DonationType;
}

export enum DonationType {
  Dormitory = "dormitory",
  Sacrifice = "sacrifice",
  Water = "water",
}

@Injectable({
  providedIn: 'root'
})
export class DonationService extends ApiService {

  //#region Endpoints
  readonly #DONATION_ENDPOINT = 'donation';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public getDonation(id: string): Observable<Donation> {
    return this.get<Donation>(`${this.#DONATION_ENDPOINT}/${id}`);
  }

  public createDonations(donations: CreateDonationInput[]): Observable<Donation> {
    return this.post(`${this.#DONATION_ENDPOINT}/create`, donations);
  }

  public setDonationVideo(donationId: string, videoUrl: string): Observable<void> {
    return this.post(`${this.#DONATION_ENDPOINT}/${donationId}/video`, { videoUrl });
  }
  //#endregion
  
}
